export const getVisibleColumnRange = ({
  columnCount,
  columnWidth,
  offsetStart,
  overscan,
  renderAllUpTo,
  scrollLeft,
  viewportWidth,
}: {
  columnCount: number
  columnWidth: number
  offsetStart: number
  overscan: number
  renderAllUpTo: number
  scrollLeft: number
  viewportWidth: number
}) => {
  if (columnCount <= renderAllUpTo || !(columnWidth > 0))
    return { startIndex: 0, endIndex: Math.max(columnCount, 0) }

  const firstVisibleIndex = Math.floor(Math.max(scrollLeft - offsetStart, 0) / columnWidth)
  const endOfLastVisibleIndex = Math.ceil(Math.max(scrollLeft + viewportWidth - offsetStart, 0) / columnWidth)

  return {
    startIndex: Math.min(Math.max(firstVisibleIndex - overscan, 0), columnCount),
    endIndex: Math.min(endOfLastVisibleIndex + overscan, columnCount),
  }
}
